import React, { Component, Fragment } from "react";
import styles from "./NewsletterPopUp.css";
import { LIB } from "../../constants/consts-types";
import { getCookieAcceptance, setCookie } from "../../services/service-cookies";
import {WP_BASE_API} from '../../services/service-wp'
import { withRouter } from "react-router-dom";

const newsletterString = "closeNewsletterPopUp";
//const { show, message, link, link_text } = this.props.data;

const { showonpage, timer } = {
  showonpage: true,
  timer: 0
};

class NewsletterPopUp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ClosePopUp: true,
      Subscribe: false,
      email: "",
      loading: false,
      RenderPopUp: false
    };
    this.closedPopUp = this.closedPopUp.bind(this);
    this.sendSubscribe = this.sendSubscribe.bind(this);
    this.handelEmailAddress = this.handelEmailAddress.bind(this);
  }

  lib_define = {
    headline: LIB.popup_newsletter_headline,
    message: LIB.popup_newsletter_message,
    reply: LIB.popup_newsletter_reply,
    placeholder: LIB.popup_newsletter_placeholder,
    link_text: LIB.popup_newsletter_link_text,
    close_text: LIB.popup_newsletter_close,
    audience_id: "6f2ae9bb04"
  };

  lib_define_press = {
    headline: LIB.popup_press_headline,
    message: LIB.popup_press_message,
    reply: LIB.popup_press_reply,
    placeholder: LIB.popup_press_placeholder,
    link_text: LIB.popup_press_link_text,
    close_text: LIB.popup_press_close,
    audience_id: "d4891fa1e1"
  };

  lib_define_education = {
    headline: LIB.popup_education_headline,
    message: LIB.popup_education_message,
    reply: LIB.popup_education_reply,
    placeholder: LIB.popup_education_placeholder,
    link_text: LIB.popup_education_link_text,
    close_text: LIB.popup_education_close,
    audience_id: "424436442c"
  };

  componentDidMount() {
    this.setState({
      ClosePopUp: getCookieAcceptance(newsletterString),
      Subscribe: false
    });
    setTimeout(
      function() {
        this.setState({ RenderPopUp: true });
      }.bind(this),
      timer
		);
  }
  sendSubscribe(event) {
    event.preventDefault();
    this.setState({
      Subscribe: true
    });
  }

  handelEmailAddress(e) {
    this.setState({ email: e.target.value });
  }

  closedPopUp(event) {
    event.preventDefault();
    setCookie(newsletterString, "true", 365);
    this.setState({
      ClosePopUp: getCookieAcceptance(newsletterString)
    });
    this.props.closeNewsletter(false);
  }

  getContent(isPress, isEducation) {
    if (isPress) {
      return this.lib_define_press;
    } else if (isEducation) {
      return this.lib_define_education;
    } else {
      return this.lib_define;
    }
  }

  formSubmit = chimp => event => {
    event.preventDefault();
    
    this.setState({loading: true})

    fetch(
      `${WP_BASE_API}/api/chimp`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          audience_id: chimp.audience_id,
          email_address: this.state.email,
          status: "subscribed",
          merge_fields: {
            FNAME: "",
            LNAME: "",
          }
        })
      }
      )
      .then(res => {
        return res.json()
      })
      .then(res => {
        this.setState({ Subscribe: true, loading: false});
      })
      .catch(err => {
        this.setState({loading: false})
        console.error("THERE WAS AN ERROR");
        console.log(Object.entries(err));
        console.log(err)
      });


    return false;
	};
	

  render() {
    //if(!show || this.state.cookiesAccepted) return null
    console.log("props", this.props.newsletter);
    if (
      (!showonpage || this.state.ClosePopUp || !this.state.RenderPopUp) &&
      !this.props.newsletter
    )
      return null;
    const currentUrl = this.props.location.pathname;

    const isPress = currentUrl && currentUrl.includes("press");
    const isEducation = currentUrl && currentUrl.includes("undervisning");

    const mailchimp = this.getContent(isPress, isEducation);

    const {
      headline,
      message,
      reply,
      placeholder,
      link_text,
      close_text,
		} = mailchimp;

    return (
      <Fragment>
        <div className={styles.popUp}>
          <div className={styles.popUpContainer}>
            <a href="/" className={styles.accept} onClick={this.closedPopUp}>
              <span>&times;</span>
            </a>
            <div
              className={styles.headline}
              dangerouslySetInnerHTML={{ __html: headline }}
            />
            <div className={styles.popUpContent}>
              {!this.state.Subscribe && (
                <div className={styles.text}>
                  <div
                    className={styles.info}
                    dangerouslySetInnerHTML={{ __html: message }}
                  />
									{this.state.loading ? <div className={styles.donutSpinner} /> : (
										<form onSubmit={this.formSubmit(mailchimp)} noValidate>
											<input
												type="text"
												name="EMAIL"
												id="MERGE0"
												className={styles.textInput}
												placeholder={placeholder}
												onChange={this.handelEmailAddress}
											/>
											<input
												type="submit"
												className={`button primary ${styles.subsrcibe}`}
												value={link_text}
											/>
										</form>
									)}
                </div>
              )}
              {this.state.Subscribe && (
                <div className={styles.text}>
                  <div
                    className={styles.info}
                    dangerouslySetInnerHTML={{ __html: reply }}
                  />
                  <a
                    href="/"
                    className={`button primary ${styles.subsrcibe}`}
                    onClick={this.closedPopUp}
                  >
                    {close_text}
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default withRouter(NewsletterPopUp);



// WEBPACK FOOTER //
// ./src/components/NewsletterPopUp/NewsletterPopUp.js